// src/components/popups/ConfirmDeleteRewardCodeDrawer.js
import React from 'react';
import './ConfirmDeleteRewardCodeDrawer.css';

export default function ConfirmDeleteRewardCodeDrawer({
  open,
  title = 'Remove reward code?',
  message = 'Are you sure you want to remove this code? This action cannot be undone. Make sure you have saved or redeemed your code.',
  onCancel = () => {},
  onConfirm = () => {},
  confirmText = 'Remove',
  cancelText = 'Cancel',
  busy = false,
}) {
  if (!open) return null;

  return (
    <div className="rcdel-overlay" onClick={onCancel}>
      <div className="rcdel-popup" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <p>{message}</p>

        <div className="rcdel-actions">
          <button className="rcdel-cancel-btn" onClick={onCancel} disabled={busy}>
            {cancelText}
          </button>

          <button className="rcdel-confirm-btn" onClick={onConfirm} disabled={busy}>
            {busy ? 'Removing…' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
